import { BusinessPremisesEntityConfig }  from '@app/modules/business-premises/presets/business-premises-entity-config.model';
import { Tss }                           from '@app/modules/tss/models/tss.model';
import { Address }                       from '@app/shared/components/address/models/address.model';
import { RequestState }                  from '@core/interfaces/api.interface';
import { IBusinessPremisesEntityEvents } from '@core/interfaces/entity.interface';
import {
	EntityActionEventEnum,
	EntityErrors
}                                        from '@models/entity.model';

// ENUMS #############################################################
// API enums *********************************************************
export enum BusinessPremisesStatusEnum {
	ACTIVE = 'active',
	DELETED = 'deleted',
	DISABLED = 'disabled'
}

// UI enums *********************************************************
export enum BusinessPremisesPresetEnum {
	BUSINESS_PREMISES = 'businessPremises',
	BULK_TAXATION_REPORTING = 'bulkTaxationReporting',
	ORGANIZATION_DETAIL_BUSINESS_PREMISES = 'organizationDetailBusinessPremises',
	ORGANIZATION_DETAIL_BULK_TAXATION_REPORTING = 'organizationDetailBulkTaxationReporting'
}


// INTERFACES ########################################################
// API interfaces ****************************************************
// UI interfaces *****************************************************
export interface IBusinessPremisesEntityActionEvent {
	action: EntityActionEventEnum;
	businessPremises: BusinessPremises;
	businessPremisesEntityConfig: BusinessPremisesEntityConfig;
}

// TYPES #############################################################
export type BusinessPremisesProp = ( keyof BusinessPremises );
export type BusinessPremisesProps = BusinessPremisesProp[];


// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)
export class BusinessPremisesTMO {
	public addressData: Address = new Address();
	public businessPremisesIdentifier: string = undefined;
	public createdBy?: string = undefined;
	public createdDate?: Date = undefined;
	public deactivationDate?: Date = undefined;
	public detailedDescription: string = undefined;
	public errors?: EntityErrors = new EntityErrors();
	public id: string = undefined;
	public lastModifiedBy?: string = undefined;
	public lastModifiedDate?: Date = undefined;
	public lastSuccessRegistrationProtocolPreviewDate?: Date = undefined;
	public name: string = undefined;
	public parentOrgId: string = undefined;
	public status: BusinessPremisesStatusEnum = undefined;
	public taxOfficeRemark?: string = undefined;
}


// MODEL USED IN APPLICATION (with additional properties)
export class BusinessPremises extends BusinessPremisesTMO {
	public etag?: string = undefined;
	public isSelected?: boolean = undefined;
	public showPlainEntity?: boolean = undefined;
	public tenantId?: string = undefined;
	public tss?: Tss = undefined; // currently only support for single entity
	public ui?: IBusinessPremisesEntityEvents = {
		requestState: RequestState.NOT_ASKED,
		requestError: undefined,
		entityActions: {}
	};
}
